angular.module( 'acme.view.application.layouts.membership.cards.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.view.application.layouts.membership.cards.create.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsMembershipCardsCreate = {
        name: 'application.layouts.membership.cards.create',
        url: '/create',
        views: {
          "subview-main": {
            controller: 'LayoutsMembershipCardsCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/membership/cards/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Membership Card Layout',
          permissions: ['MEMBERSHIP_CARD_LAYOUTS_CREATE']
        },
        resolve: {
          ThemesData: ['ApiService', function(ApiService) {
            return ApiService.themes.detail();
          }]
        }
      },
      layoutsMembershipCardsEdit = {
        name: 'application.layouts.membership.cards.edit',
        url: '/:id/edit',
        views: {
          "subview-main": {
            controller: 'LayoutsMembershipCardsCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/membership/cards/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Edit membership cards layout',
          permissions: ['MEMBERSHIP_CARD_LAYOUTS_UPDATE']
        },
        resolve: {
          ThemesData: ['ApiService', function(ApiService) {
            return ApiService.themes.detail();
          }]
        }
      };

    $stateProvider
      .state(layoutsMembershipCardsCreate)
      .state(layoutsMembershipCardsEdit);
});
